<template>
  <div class="coupon-data">
    <common-layout>
      <div slot="header">
        <h3>创新券批次统计数据</h3>
      </div>
      <div slot="container">
        <div class="coupon-data.header">
          <section>
            <el-button type="primary" @click="downFn">下载Excel模板</el-button>

            <el-button type="success" @click="exportFn">导入Excel</el-button>

            <el-button type="danger" @click="deleteAll">批量删除</el-button>
          </section>
          <section>
            <el-input
                v-model="searchValue"
                class="input-with-select"
                clearable
                placeholder="请输入内容"
                style="width: 240px; margin-right: 20px"
                @clear="search"
                @keyup.enter.native="search"
            >
              <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="search"
              ></el-button>
            </el-input>
            <el-date-picker
                v-model="dateTime"
                align="center"
                format="yyyy"
                placeholder="选择年"
                style="width: 100%"
                type="year"
                value-format="yyyy"
                @change="search"
            >
            </el-date-picker>
            <div class="select">
              <span class="lable">批次</span>
              <el-select
                  v-model="select"
                  clearable
                  placeholder="请选择"
                  style="width: 180px"
                  @change="search"
              >
                <el-option
                    v-for="(item, index) in batchNumOps"
                    :key="index"
                    :label="item.name"
                    :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div class="select">
              <span class="lable" style="width:80px">服务类型</span>
              <el-select
                  v-model="select1"
                  clearable
                  placeholder="请选择"
                  style="width: 180px"
                  @change="search"
              >
                <el-option
                    v-for="(item, index) in serviceTypeNames"
                    :key="index"
                    :label="item"
                    :value="item"
                ></el-option>
              </el-select>
            </div>
            <el-button class="coupon-data.addBtn" @click="exportFn"
            >重新上传
            </el-button
            >
          </section>
        </div>
        <div class="total">
          <p v-for="(item,index) in totalList" :key="index">{{ item.name }}
            <span>{{ item.num }}</span>
          </p>
        </div>
        <div class="float-index.table tables">
          <el-table
              ref="multipleTable"
              :data="tableData"
              :header-cell-style="{ background: '#E5F3FE', color: '#623AA2' }"
              class="table"
              style="width: 100%"
              @selection-change="selectionChange"
          >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column align="center" label="序号" type="index">
              <template slot-scope="scope">
                <span>{{
                    scope.$index + (current_page - 1) * page_size + 1
                  }}</span>
              </template>
            </el-table-column>
            <el-table-column
                align="center"
                label="单位名称"
                prop="name"
            ></el-table-column>
            <el-table-column
                align="center"
                label="服务类型"
                prop="serviceTypeName"
            ></el-table-column>
            <el-table-column
                align="center"
                label="服务企业及团队（家）"
                prop="serviceUnitNum"
            ></el-table-column>
            <el-table-column
                :formatter="formatter"
                align="center"
                label="服务合同金额（万元）"
                prop="serviceContractMoney"
            ></el-table-column>
            <el-table-column
                :formatter="formatter"
                align="center"
                label="创新券金额（万元）"
                prop="innovateCouponMoney"
            ></el-table-column>
            <el-table-column
                align="center"
                label="服务次数（次）"
                prop="serviceNum"
            ></el-table-column>
            <el-table-column
                align="center"
                label="服务项目（项）"
                prop="serviceItemNum"
            ></el-table-column>
            <el-table-column
                align="center"
                label="服务合同（份）"
                prop="serviceContractNum"
            ></el-table-column>
            <el-table-column
                align="center"
                label="服务成果（份）"
                prop="serviceGainNum"
            ></el-table-column>
            <el-table-column
                align="center"
                label="服务记录单（份）"
                prop="serviceRecordNum"
            ></el-table-column>
            <el-table-column
                align="center"
                label="财务证明（份）"
                prop="financialCertNum"
            ></el-table-column>
            <el-table-column
                align="center"
                label="年度"
                prop="year"
            ></el-table-column>
            <el-table-column
                align="center"
                label="批次"
                prop="batchNum"
            ></el-table-column>
            <el-table-column align="center" label="操作">
              <template slot-scope="scope">
                <el-button
                    class="mini_btn"
                    size="mini"
                    type="danger"
                    @click="handleDelete(scope.$index, scope.row)"
                >删除
                </el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
            :current-page.sync="current_page"
            :page-size="page_size"
            :total="total"
            layout="total,prev, pager, next"
            style="text-align: left; margin: 20px 0"
            @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </common-layout>
  </div>
</template>

<script>
import CommonLayout from "../../components/common-layout.vue";
import {ExportFn, FunDownload} from "@/utils/tool";

export default {
  components: {
    CommonLayout,
  },
  data() {
    return {
      totalList: [
        {
          name: '单位数(家)',
          num: 0,
          unit: '家'
        },
        {
          name: '服务企业及团队(家)',
          num: 0,
          unit: '家'
        },
        {
          name: '服务合同金额(万元)',
          num: 0,
          unit: '万元'
        },
        {
          name: '创新券金额(万元)',
          num: 0,
          unit: '万元'
        },
        {
          name: '服务次数(次)',
          num: 0,
          unit: '次'
        },
        {
          name: '服务项目(项)',
          num: 0,
          unit: '项'
        },
        {
          name: '服务合同(份)',
          num: 0,
          unit: '份'
        },
        {
          name: '服务成果(份)',
          num: 0,
          unit: '份'
        },
        {
          name: '服务记录单(份)',
          num: 0,
          unit: '份'
        },
        {
          name: '财务证明(份)',
          num: 0,
          unit: '份'
        },
      ],
      serviceTypeNames: [],
      total: 0,
      current_page: 1,
      page_size: 10,
      dateTime: "",
      select: "",
      select1: "",
      tableData: [],
      batchNumOps: [],
      deleteRow: "",
      searchValue: "",
      year: "",
      batchNum: "",
    };
  },
  created() {
    this.getData(`${urlConfig.devUrl}apij2/admin-api/innovation/innovate-coupon-stat/page`, {is_valid: 0});
  },
  methods: {
    //选择
    selectionChange(selection) {
      this.deleteRow = "";
      if (selection.length !== 0) {
        let arr = [];
        selection.forEach((item) => {
          arr.push(item.id);
        });
        this.deleteRow = arr?.join(",") || "";
      }
    },
    //批量删除
    deleteAll() {
      if (this.deleteRow) {
        this.$confirm("此操作将批量删除, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true,
        })
            .then(() => {
              this.http
                  .delete(`${urlConfig.devUrl}apij2/admin-api/innovation/innovate-coupon-stat/delete?ids=${this.deleteRow}`)
                  .then((res) => {
                    if (res.code === 0) {
                      this.getData(`${urlConfig.devUrl}apij2/admin-api/innovation/innovate-coupon-stat/page`,
                          {
                            search: this.searchValue,
                            is_valid: 0,
                            year: this.year,
                            batchNum: this.batchNum
                          });
                      this.$message({
                        type: "success",
                        message: "删除成功",
                      });
                    } else {
                      this.$message({
                        message: "失败！",
                        type: "error",
                      });
                    }
                  });
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "已取消删除",
              });
            });
      } else {
        this.$message({
          type: "warning",
          message: "请选择删除的记录",
        });
      }
    },
    //删除
    handleDelete(index, row) {
      this.$confirm("此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
          .then(() => {
            this.http
                .delete(`${urlConfig.devUrl}apij2/admin-api/innovation/innovate-coupon-stat/delete?ids=${row.id}`)
                .then((res) => {
                  if (res.code === 0) {
                    this.getData(`${urlConfig.devUrl}apij2/admin-api/innovation/innovate-coupon-stat/page`,
                        {
                          search: this.searchValue,
                          is_valid: 0,
                          year: this.year,
                          batchNum: this.batchNum
                        });
                    this.$message({
                      type: "success",
                      message: "删除成功",
                    });
                  } else {
                    this.$message({
                      message: "失败！",
                      type: "error",
                    });
                  }
                });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
    },
    // 列表数据回填
    formatter(row, column, cellValue, index) {
      switch (column.property) {
        case "serviceContractMoney": {
          return (cellValue / 1).toFixed(4);
          break;
        }
        case "innovateCouponMoney": {
          return (cellValue / 1).toFixed(4);
          break;
        }
        default: {
          break;
        }
      }
    },
    async exportFn() {
      let res = await ExportFn("/innovate_coupon_stat/export");
      if (res.code === 0) {
        this.$message.success("导入成功");

        this.ResetSearch(["dateTime", "select"]);
        await this.getData(`${urlConfig.devUrl}apij2/admin-api/innovation/innovate-coupon-stat/page`,
            {
              is_valid: 0
            });
      } else {
        this.$message.error(res.status);
      }
    },
    search() {
      this.year = this.dateTime ? this.dateTime + "年" : "";
      // this.batchNum = this.select ? this.select : "";
      this.batchNum = this.select;
      this.getData(`${urlConfig.devUrl}apij2/admin-api/innovation/innovate-coupon-stat/page`,
          {
            search: this.searchValue,
            is_valid: 0,
            year: this.year,
            batchNum: this.batchNum,
            serviceTypeName: this.select1
          });
    },

    //   下载
    downFn() {
      FunDownload(
          this.imgUrl + "lanzhoufile/创新券批次统计模板.xlsx",
          "创新券批次统计模板.xlsx"
      );
    },

    // 获取列表
    async getData(url, data) {
      const res = await this.http.post(url, data);
      if (res.code === 0) {
        this.tableData = res.data.pageResult.data.map((el) => {
          el.innovateCouponMoney = Number(el.innovateCouponMoney);
          el.serviceContractMoney = Number(el.serviceContractMoney);
          return el;
        });
        this.total = res.data.pageResult.total;
        this.batchNumOps = []
        this.serviceTypeNames = res.data.serviceTypeNames
        Object.keys(res.data.batchNum).forEach(item => {
          this.batchNumOps.push({
            value: item,
            name: res.data.batchNum[item]
          })
        })
        this.totalList[0].num = res.data.pageResult.total
        this.totalList[1].num = res.data.stat.serviceUnitNumTotal
        this.totalList[2].num = res.data.stat.serviceContractMoneyTotal
        this.totalList[3].num = res.data.stat.innovateCouponMoneyTotal
        this.totalList[4].num = res.data.stat.serviceNumTotal
        this.totalList[5].num = res.data.stat.serviceItemNumTotal
        this.totalList[6].num = res.data.stat.serviceContractNumTotal
        this.totalList[7].num = res.data.stat.serviceGainNumTotal
        this.totalList[8].num = res.data.stat.serviceRecordNumTotal
        this.totalList[9].num = res.data.stat.financialCertNumTotal
        // this.batchNumOps = Object.values(res.data.batchNums);
      }
    },
    //   分页改变
    handleCurrentChange(e) {
      this.getData(`${urlConfig.devUrl}apij2/admin-api/innovation/innovate-coupon-stat/page`,
          {
            search: this.searchValue,
            is_valid: 0,
            year: this.year,
            batchNum: this.batchNum,
            page: e,
            serviceTypeName: this.select1
          });
    },
  },
};
</script>

<style lang="scss">
@include component(coupon-data) {
  height: 100%;

  @include part(header) {
    display: flex;
    justify-content: space-between;

    > section {
      display: flex;
      align-items: center;

      .select {
        display: flex;
        align-items: center;
        margin-right: 10px;

        .lable {
          display: inline-block;
          width: 50px;
        }
      }
    }
  }

  @include part(searchBtn) {
    margin-left: 10px;
  }

  @include part(addBtn) {
    margin-right: 30px !important;
    background: #623aa2 !important;
    color: #fff;
    border: none;
  }

  @include part(table) {
    margin-top: 30px;
  }
  .tables {
    margin-top: 0;
  }
  .total {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin: 10px 0;

    p {
      padding: 0 10px;
      font-size: 16px;

      span {
        color: rgb(98, 58, 162);
        font-size: 18px;
        margin-left: 5px;
      }
    }
  }
}
</style>
